import SbuxDialog2 from "../../../../../../components/SbuxDialog2";
import SbuxTranslate from "../../../../../../components/SbuxTranslate";
import { deleteQueue } from "../../../../../../services/queue";
import {
  Box,
  DialogContent,
  Button,
  DialogActions,
  Typography,
} from "@mui/material";
import { useAppDispatch } from "../../../../../../store/types";
import type { ReactNode } from "react";
import type { QueueRecord } from "../types";

interface Props {
  row: QueueRecord;
  title: ReactNode;
  name: string;
  open: boolean;
  toggleOpen: () => void;
}

const QueueDeleteDialog = ({ row, title, name, open, toggleOpen }: Props) => {
  const dispatch = useAppDispatch();

  const handleOkayClick = async () => {
    await dispatch(deleteQueue(row?.Id ?? ""));
  };

  const dialogConfig = {
    title,
    hasBackdrop: false,
    asModal: true,
  };

  return (
    <SbuxDialog2 open={open} config={dialogConfig} handleOnClose={toggleOpen}>
      <DialogContent dividers>
        <Typography variant="h5">
          <SbuxTranslate>{`Are you sure you want to delete `}</SbuxTranslate>
          <span>{`${name}?`}</span>
        </Typography>
      </DialogContent>

      <DialogActions>
        <Box className="actionContainer">
          <Button variant="contained" size="medium" onClick={handleOkayClick}>
            <SbuxTranslate>{`Okay`}</SbuxTranslate>
          </Button>
          <Button variant="outlined" size="medium" onClick={toggleOpen}>
            <SbuxTranslate>{`Cancel`}</SbuxTranslate>
          </Button>
        </Box>
      </DialogActions>
    </SbuxDialog2>
  );
};

export default QueueDeleteDialog;
